module.exports = __webpack_public_path__ + "media/images/badge/cecchino-a72cd23c382f87108db76a709253aa38.png";